// @ts-nocheck
import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ArrowLeftIcon,
  ShieldCheckIcon,
  UserPlusIcon,
} from '@heroicons/react/24/outline';
import Breadcrumb from '../../components/Breadcrumb';
import { URL } from '../../service/Service';
import { useI18n } from '../../i18n/I18nContext';

const AdminRegisterPage = () => {
  const navigate = useNavigate();
  const { language } = useI18n();
  const [form, setForm] = useState({ email: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    setSubmitting(true);
    try {
      const token = sessionStorage.getItem('jwt');
      await axios.post(`${URL}/api/admin/users/createadmin`, {
        userEmail: form.email,
        companyID: 'EUPAGO_A',
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Accept-Language': language.toLowerCase(),
        },
      });
      navigate('/admin/users');
    } catch {
      setError('Não foi possível criar o administrador. Confirme os dados introduzidos.');
    } finally {
      setSubmitting(false);
    }
  };

  const pages = [
    { name: 'Dashboard', href: '/admin/dashboard', current: false },
    { name: 'Utilizadores', href: '/admin/users', current: false },
    { name: 'Novo administrador', href: '/adminregisterpage', current: true },
  ];

  return (
    <main className="min-h-[calc(100vh-5rem)] bg-gradient-to-br from-slate-50 via-white to-emerald-50/50 px-4 py-7 sm:px-8 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <Breadcrumb pages={pages} />
        <div className="mx-auto mt-8 grid max-w-5xl overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm lg:grid-cols-[0.8fr_1.2fr]">
          <aside className="bg-gradient-to-br from-green-cl to-emerald-800 p-8 text-white sm:p-10">
            <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/10">
              <ShieldCheckIcon className="h-7 w-7" />
            </span>
            <p className="mt-8 text-xs font-bold uppercase tracking-[0.22em] text-emerald-100">Administração</p>
            <h1 className="mt-3 text-3xl font-extrabold !text-white">Novo administrador</h1>
            <p className="mt-4 text-sm leading-6 text-emerald-50/80">
              Crie uma conta com acesso à gestão global de formulários, utilizadores e atividade da plataforma.
            </p>
            <div className="mt-8 rounded-2xl border border-white/15 bg-white/10 p-4 text-sm leading-6 text-emerald-50">
              Conceda este perfil apenas a pessoas autorizadas a gerir toda a plataforma.
            </div>
          </aside>

          <section className="p-6 sm:p-10">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-700">
                <UserPlusIcon className="h-6 w-6" />
              </span>
              <div>
                <h2 className="text-2xl font-extrabold text-slate-950">Dados da conta</h2>
                <p className="mt-1 text-sm text-slate-500">Preencha os dados do novo administrador.</p>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="mt-8 space-y-5">
              <div>
                <label htmlFor="admin-email" className="mb-2 block text-sm font-semibold text-slate-800">Email</label>
                <input
                  id="admin-email"
                  type="email"
                  value={form.email}
                  onChange={(event) => setForm((current) => ({ ...current, email: event.target.value }))}
                  autoComplete="email"
                  required
                  placeholder="nome@empresa.pt"
                  className="block w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-emerald-700 focus:ring-2 focus:ring-emerald-100"
                />
              </div>
              <p className="text-sm leading-6 text-slate-500">
                O novo administrador receberá um email com um link para definir a sua palavra-passe. O link é válido durante 15 minutos. Se expirar, pode pedir outro em Recuperar palavra-passe.
              </p>
              {error && <div role="alert" className="rounded-2xl border border-red-200 bg-red-50 p-4 text-sm font-medium text-red-700">{error}</div>}

              <div className="flex flex-col-reverse gap-3 border-t border-slate-100 pt-6 sm:flex-row sm:justify-between">
                <button type="button" onClick={() => navigate('/admin/users')} className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 px-4 py-3 text-sm font-bold text-slate-700">
                  <ArrowLeftIcon className="h-4 w-4" />
                  Voltar
                </button>
                <button type="submit" disabled={submitting} className="inline-flex min-w-48 items-center justify-center rounded-xl bg-green-cl px-5 py-3 text-sm font-bold text-white shadow-sm hover:bg-green-eupago disabled:opacity-50">
                  {submitting ? 'A criar...' : 'Criar e enviar convite'}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </main>
  );
};

export default AdminRegisterPage;
